import { Box } from '@mui/material';
import QuizHeader from '../../common/QuizHeader';
import QuizQuestion from '../../common/QuizQuestion';
import QuizContainer from '../../common/QuizContainer';
import QuizButton, { ButtonType } from '../../common/QuizButton';
import { useQuizState } from '@providers/QuizProvider/QuizProvider.hooks';
import {
  RELATIONSHIP_ANSWERS,
  RelationshipWithAlcohol,
} from '@providers/QuizProvider/QuizProvider.types';
import QuizStepBackgroundWrapper from '../../common/QuizStepBackgroundWrapper';

function Step2(
  {
    stepNumber = 2,
    stepsNumber = 19,
    backToMain = false,
  }: {
    stepNumber?: number;
    stepsNumber?: number;
    backToMain?: boolean;
  }
) {
  const { setStep, setQuizData } = useQuizState();
  const handleClick = (type: RelationshipWithAlcohol) => {
    setQuizData((prev) => ({
      ...prev,
      alcoholRelationship: type,
    }));
    setStep((prev) => prev + 1);
  };

  return (
    <QuizStepBackgroundWrapper>
      <QuizHeader
        onBack={() => {
          setStep((prev) => prev - 1);
        }}
        stepNumber={stepNumber}
        stepsNumber={stepsNumber}
      ></QuizHeader>
      <QuizQuestion text="How would you like to redefine your relationship with alcohol?"></QuizQuestion>
      <QuizContainer>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            marginBottom: '30px',
          }}
        >
          {Object.keys(RELATIONSHIP_ANSWERS).map((key) => (
            <QuizButton
              key={key}
              onClick={() =>
                handleClick(key as keyof typeof RELATIONSHIP_ANSWERS)
              }
              variant={ButtonType.WHITE}
              text={
                RELATIONSHIP_ANSWERS[key as keyof typeof RELATIONSHIP_ANSWERS]
              }
            ></QuizButton>
          ))}
        </Box>
      </QuizContainer>
    </QuizStepBackgroundWrapper>
  );
}

export default Step2;
